import { mapGetters } from "vuex";

export default {
	name: "EmptyStateModal",
	props: ["isVisible"],
	emits: ["open-category-modal", "update:isVisible"],
	computed: {
		...mapGetters("staticContent", ["getTranslations"]),
	},
	methods: {
		goToCategories() {
			this.$emit("open-category-modal");
		},
	},
};
